"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getSubscriptionProfile = void 0;
var _fetching = require("@ori/fetching");
var _logger = require("../logger");
var _queriesNet = require("../queries-net");
const localLogger = _logger.mainLogger.createChild('getSubscriptionProfile');
const getSubscriptionProfile = async ({
  graphQlNetUrl,
  headers
}) => {
  try {
    const {
      customer
    } = await (0, _fetching.fetchGraphql)({
      query: _queriesNet.subscriptionProfileQuery,
      url: graphQlNetUrl,
      headers
    });
    const subscriptionProfile = customer?.subscriptionProfile;
    return subscriptionProfile;
  } catch (error) {
    localLogger.error(new Error('fetchGraphql', {
      cause: error
    }));
    throw error;
  }
};
exports.getSubscriptionProfile = getSubscriptionProfile;